import { useRef } from 'react'
import { startCooking, type CookState } from '../lib/cooking'

/**
 * Cooking sessions by planned meal (or "recipe:<id>" when cooked straight from
 * a recipe page), kept for as long as the app is open:
 * closing cooking mode with ✕ and tapping Cook again carries on where it was —
 * the stage, what's been got out, and the timers, which run on wall-clock
 * deadlines and so are right whenever they're looked at again. A reload starts
 * over; Mark as cooked forgets the meal.
 */
export function useCookingSessions() {
  const sessions = useRef(new Map<string, CookState>())
  return {
    open: (mealId: string, now: number): CookState => sessions.current.get(mealId) ?? startCooking(now),
    save: (mealId: string, s: CookState) => { sessions.current.set(mealId, s) },
    drop: (mealId: string) => { sessions.current.delete(mealId) },
  }
}
